document.addEventListener('DOMContentLoaded', () => {
    
    // ----------------------------------------------------------------------
    // SCHRITT 1: Segmente dynamisch aus dem DOM auslesen (anstatt statisch)
    // ----------------------------------------------------------------------
    const segmentsData = [];
    const chartSegments = document.querySelectorAll('.chart-svg .chart-segment[data-segment-id]');
    
    // Die Basiswinkel für die Berechnung festlegen
    const totalSegments = chartSegments.length;
    const anglePerSegment = totalSegments > 0 ? 360 / totalSegments : 0;
    
    // Wenn keine Segmente vorhanden, beenden
    if (totalSegments === 0) {
        console.warn('Keine Diagramm-Segmente gefunden.');
        return;
    }

    // Schleife über alle Segmente im SVG, um die Datenstruktur zu erstellen
    chartSegments.forEach((element, index) => {
        const startAngle = index * anglePerSegment;
        const endAngle = (index + 1) * anglePerSegment;
        
        segmentsData.push({
            id: element.getAttribute('data-segment-id'), // z.B. segment-1
            startAngle: startAngle,
            endAngle: endAngle,
            baseRadius: 40 // Radius beibehalten
        });
    });

    // ----------------------------------------------------------------------
    // SCHRITT 2: Bestehende Funktionen beibehalten/verbessern
    // ----------------------------------------------------------------------
    
    const getMidpointAngle = (startAngle, endAngle) => {
        let midAngle = (startAngle + endAngle) / 2;
        // Bei Segmenten, die den 360/0-Punkt überschreiten (nicht relevant bei perfekter Verteilung)
        if (startAngle > endAngle) { 
            midAngle = (startAngle + endAngle + 360) / 2;
        }
        return midAngle;
    };

    const positionContents = () => {
        const svg = document.querySelector('.chart-svg');
        const chartContainer = document.querySelector('.chart-container');
        
        if (!svg || !chartContainer) return;

        // Nutze getBoundingClientRect() für die genaue Größe des Containers
        const svgRect = chartContainer.getBoundingClientRect(); 
        
        segmentsData.forEach(seg => {
            const content = document.getElementById(`${seg.id}-container`);
            if (!content) return;

            const midAngle = getMidpointAngle(seg.startAngle, seg.endAngle);
            // -90 Grad, um bei 12 Uhr (Top) zu starten, da Math.cos bei 3 Uhr (Rechts) startet
            const angleRad = (midAngle - 90) * Math.PI / 180;
            
            // Koordinaten im 0-100 SVG-Koordinatensystem
            const svgX = 50 + seg.baseRadius * Math.cos(angleRad);
            const svgY = 50 + seg.baseRadius * Math.sin(angleRad);
            
            // Konvertierung in Pixelkoordinaten relativ zum Container
            const containerX = (svgX / 100) * svgRect.width;
            const containerY = (svgY / 100) * svgRect.height;

            content.style.left = `${containerX}px`;
            content.style.top = `${containerY}px`;
            content.style.transform = `translate(-50%, -50%)`;
        });
    };

    const handleMouseActions = (event, isHovering) => {
        let targetSegmentId = null;
        
        // Finde das Segment-ID über das Attribut
        const closestSegment = event.target.closest('[data-segment-id]'); 
        const closestContent = event.target.closest('.segment-content-inner');

        if (closestSegment) {
            targetSegmentId = closestSegment.getAttribute('data-segment-id');
        } else if (closestContent) {
            targetSegmentId = closestContent.parentElement.id.replace('-container', '');
        }

        segmentsData.forEach(seg => {
            // Finde alle Segmente mit der passenden ID (z.B. image-Segment)
            const segmentElements = document.querySelectorAll(`[data-segment-id="${seg.id}"]`);

            const contentInner = document.getElementById(`${seg.id}-container`)?.querySelector('.segment-content-inner');
            
            if (seg.id === targetSegmentId && isHovering) {
                segmentElements.forEach(el => el.classList.add('chart-segment-hovered'));
                if (contentInner) {
                    contentInner.classList.add('segment-content-hovered-inner');
                }
            } else {
                segmentElements.forEach(el => el.classList.remove('chart-segment-hovered'));
                if (contentInner) {
                    contentInner.classList.remove('segment-content-hovered-inner');
                }
            }
        });
    };

    // ----------------------------------------------------------------------
    // SCHRITT 3: Events an das Haupt-Chart-Element binden
    // ----------------------------------------------------------------------
    
    const chartContainer = document.querySelector('.chart-container');
    if (chartContainer) {
        chartContainer.addEventListener('mouseover', (e) => handleMouseActions(e, true));
        chartContainer.addEventListener('mouseout', (e) => handleMouseActions(e, false));
    }
    
    // Initial-Positionierung und bei Größenänderung
    window.addEventListener('load', positionContents);
    window.addEventListener('resize', positionContents);
    // Sofortige Ausführung, falls das DOM schon bereit ist
    positionContents(); 
});